import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustSignals = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: 'Your data is protected with 256-bit SSL encryption'
    },
    {
      icon: 'Lock',
      title: 'GDPR Compliant',
      description: 'Full compliance with data protection regulations'
    },
    {
      icon: 'CheckCircle',
      title: 'SOC 2 Certified',
      description: 'Independently audited security controls'
    }
  ];

  const testimonials = [
    {
      id: 1,
      name: 'Sarah Johnson',
      role: 'Sales Director',
      company: 'TechCorp',
      avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
      quote: "LeadGen Pro increased our qualified leads by 300% in just 2 months."
    },
    {
      id: 2,
      name: 'Michael Chen',
      role: 'Marketing Manager',
      company: 'DataSoft',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
      quote: "The AI-powered lead discovery is incredibly accurate and saves us hours daily."
    },
    {
      id: 3,
      name: 'Jennifer Martinez',
      role: 'Business Owner',
      company: 'CloudTech',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
      quote: "Best ROI we\'ve seen from any lead generation platform. Highly recommended!"
    }
  ];

  const certifications = [
    {
      name: 'SSL Certificate',
      badge: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=80&h=80&fit=crop'
    },
    {
      name: 'GDPR Compliant',
      badge: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=80&h=80&fit=crop'
    },
    {
      name: 'SOC 2 Type II',
      badge: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=80&h=80&fit=crop'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Security Features */}
      <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="Shield" size={20} className="text-primary mr-2" />
          Enterprise Security
        </h3>
        <div className="space-y-4">
          {securityFeatures?.map((feature, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name={feature?.icon} size={16} className="text-primary" />
              </div>
              <div>
                <h4 className="text-sm font-medium text-foreground">{feature?.title}</h4>
                <p className="text-xs text-muted-foreground mt-1">{feature?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Testimonials */}
      <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
        <h3 className="text-lg font-semibold text-foreground mb-6 flex items-center">
          <Icon name="Star" size={20} className="text-warning mr-2" />
          Trusted by 10,000+ Businesses
        </h3>
        <div className="space-y-6">
          {testimonials?.slice(0, 2)?.map((testimonial) => (
            <div key={testimonial?.id} className="border-l-4 border-primary/30 pl-4">
              <div className="flex items-center space-x-4 mb-3">
                <div className="w-12 h-12 rounded-full overflow-hidden ring-2 ring-primary/20">
                  <Image
                    src={testimonial?.avatar}
                    alt={`${testimonial?.name} - ${testimonial?.role}`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground">{testimonial?.name}</p>
                  <p className="text-xs text-muted-foreground">
                    {testimonial?.role} at {testimonial?.company}
                  </p>
                </div>
              </div>
              <p className="text-sm text-muted-foreground italic leading-relaxed">
                "{testimonial?.quote}"
              </p>
            </div>
          ))}
        </div>
      </div>
      
      {/* Certifications */}
      <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="Award" size={20} className="text-accent mr-2" />
          Certifications
        </h3>
        <div className="flex items-center justify-center space-x-4">
          {certifications?.map((cert, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 mx-auto mb-2 rounded-md overflow-hidden bg-muted">
                <Image
                  src={cert?.badge}
                  alt={cert?.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="text-xs text-muted-foreground">{cert?.name}</p>
            </div>
          ))}
        </div>
      </div>
      
      {/* Stats */}
      <div className="grid grid-cols-3 gap-4 text-center">
        <div className="bg-card border border-border rounded-lg p-4 shadow-elevation-1">
          <div className="text-2xl font-bold text-primary">10K+</div>
          <div className="text-xs text-muted-foreground">Active Users</div>
        </div>
        <div className="bg-card border border-border rounded-lg p-4 shadow-elevation-1">
          <div className="text-2xl font-bold text-accent">99.9%</div>
          <div className="text-xs text-muted-foreground">Uptime</div>
        </div>
        <div className="bg-card border border-border rounded-lg p-4 shadow-elevation-1">
          <div className="text-2xl font-bold text-secondary">24/7</div>
          <div className="text-xs text-muted-foreground">Support</div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;